module.exports = __webpack_public_path__ + "static/5-f47e8a6239e09cd533f73ddb62df0658.jpg";